<template>
	<div>
		<div class="max-height-200">

			<b-container>
				<b-row class="mb-2">
					<b-col>
						<b-input-group size="sm" class="shadowed-group">
							<b-form-input size="sm" id="color"
										  v-model="wrappedSearchForm.keyword"
										  :placeholder="$t('incomes.search.search')">
							</b-form-input>
							<b-input-group-addon>
								<b-button @click="asyncFind">
									<i class="fa fa-search"></i>
								</b-button>
							</b-input-group-addon>
							<b-input-group-addon v-if="wrappedSearchForm.keyword.length>0">
								<b-button @click="clear">
									<i class="fa fa-close"></i>
								</b-button>
							</b-input-group-addon>

						</b-input-group>
					</b-col>
				</b-row>
				<div class="generalTableClass">
					<table class="table tabled-bordered">
						<thead>
						<tr>
							<th>&#9745;</th>
							<th>{{ $t('goods.name') }}</th>
							<th> {{ $t('goods.artikul') }}</th>
							<th> {{ $t('goods.color') }}</th>
							<th> {{ $t('goods.size') }}</th>
							<th> {{ $t('goods.gender') }}</th>
							<th>{{ $t('goods.barcode') }}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item in notWrapped">
							<td>
								<b-checkbox v-model="item.checked" @change="setItem($event, item)"></b-checkbox>
							</td>
							<td>
								<span>{{ item.name }}</span>
							</td>
							<td> {{ item.artikul }}</td>
							<td> {{ item.colorName }}</td>
							<td> {{ item.size }}</td>
							<td> {{ item.genderName }}</td>
							<td> {{ item.barcode }}</td>
						</tr>
						</tbody>
					</table>
				</div>

			</b-container>


		</div>
		<div class="mt-1">
			<hr>
			<b-button class="pull-right" variant="primary" @click="save" size="sm">{{ $t('save') }}</b-button>
		</div>
	</div>
</template>

<script>
	import GoodsService from "../../../../services/goods.service";

	export default {
		name: 'AddChildren',

		props: {
			defaults: {
				type: Array
			},
			wrappedSearchFormOld: {
				type: Object,
				default: () => {
					return {
						categoryId: null,
						sub: null,
						sub2: null,
						sub3: null,
						keyword: "",
						genderId: null,
						brandId: null,
						colorId: null
					}
				}
			}
		},

		data() {
			return {
				items: [],
				selected: [],
				isLoading: false,
				search: {
					page: 1,
					limit: 50,
					attributes: Object.assign({}, this.wrappedSearchForm)
				},
				wrappedSearchForm: {
					categoryId: null,
					sub: null,
					sub2: null,
					sub3: null,
					keyword: "",
					genderId: null,
					brandId: null,
					colorId: null
				},
			}
		},

		methods: {
			asyncFind() {
				this.isLoading = true;
				this.search.attributes = Object.assign({}, this.wrappedSearchForm);
				GoodsService.fetchGoodsForWrapped(this.search).then(response => {
					this.items = response.data.items;
					this.isLoading = false;
				}).catch(() => {
					this.isLoading = false;
				})
			},
			setItem($event, item) {
				if ($event) {
					this.selected.push({
						wrappedId: item.id,
						color: item.color,
						model: item.model,
						sku: item.sku,
						barcode: item.barcode,
						size: item.size,
						name: item.name,
						amount: 0
					});
				} else {
					this.selected.map((selected, i) => {
						if (selected.wrappedId === item.id) {
							this.selected.splice(i, 1);
						}
					})
				}
			},
			save() {
				this.$emit('success', this.selected);
			},
			isChecked(id) {
				return this.getDef.find(item => this.included(item, id));
			},
			included(attr, value) {
				return attr.wrappedId === value;
			},
			clear() {
				this.wrappedSearchForm.keyword = '';
				this.asyncFind();
			}
		},
		computed: {
			notWrapped: function () {
				return this.items.filter(item => {
					if (!item.wrapped && item.id !== this.parentId) {
						item['count'] = 0;
						(this.isChecked(item.id)) ? item['checked'] = true : item['checked'] = false;

						return item
					}
				})
			},
			getDef() {
				return this.defaults || [];
			}
		},
		mounted() {
			this.asyncFind();
			setTimeout(() => {
				this.selected = this.getDef;
			}, 200);
		},
		created() {

		},
		watch: {
			'wrappedSearchForm': {
				deep: true,
				handler() {
					this.asyncFind();
				}
			}
		}
	}
</script>

<style scoped>

	.max-height-200 {
		max-height: 250px;
		overflow: auto;
	}

</style>
